import Users from "./index";

export const userRoutes = () => [
  {
    path: "/admin/users/user",
    component: Users,
    layout: "admin",
    routeType: "admin",
    title: "User Management",
  },
];
